module.exports = __webpack_public_path__ + "media/images/mypage/challengers/projects/open_requests/passed-6362fc74f2141ca4433e8eb4cc38405e.svg";